InvitationList = require 'models/collections/invitation-list'
OrganizationInvitation = require 'models/organization-invitation'

module.exports = class OrganizationInvitationList extends InvitationList
  model: OrganizationInvitation



// WEBPACK FOOTER //
// ./app/scripts/models/collections/organization-invitation-list.coffee